import { Component, Input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Destructible, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective } from '@rspl-ui';

@Component({
  selector: 'app-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss'],
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, MatIcon],
})
export class PageFooterComponent extends Destructible {
  @Input() hasBack = false;
  @Input() hideContinue? = false;

  readonly onBack = output();
  readonly onSubmit = output();

  constructor() {
    super();
  }
}
